import { render, staticRenderFns } from "./AScopesTab.vue?vue&type=template&id=5e592e0e&"
import script from "./AScopesTab.vue?vue&type=script&lang=js&"
export * from "./AScopesTab.vue?vue&type=script&lang=js&"
import style0 from "./AScopesTab.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports